import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import {
  FunnelStepId,
  ListingFunnelStepsInterface,
} from 'modules/funnels/funnel/types/funnel-step-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useBTestFunnelSteps(funnelStepId?: FunnelStepId, shouldFetch?: boolean) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ListingFunnelStepsInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: bFunnelStepsData } = useSWR(() => {
    if (user && funnelStepId && shouldFetch) {
      return `${FUNNELS_API}/steps/${funnelStepId}/step-b`
    }
    return null
  }, fetcher)

  return { bFunnelStepsData }
}
